import { cva, type VariantProps } from 'class-variance-authority'
export { default as Checkbox } from './Checkbox.vue'

export const checkboxVariants = cva(
  'peer h-4 w-4 shrink-0 rounded-sm border ring-offset-background focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-ring focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50 data-[state=checked]_text-primary-foreground',
  {
    variants: {
      variant: {
        default: 'border-primary data-[state=checked]_bg-primary',
        internal: 'border-internal data-[state=checked]_bg-internal',
        dora: 'border-accent-hover data-[state=checked]_bg-accent-hover',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type CheckboxVariants = VariantProps<typeof checkboxVariants>
